import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DsButtonModule, DsIconModule, DsTagModule, DsTooltipDirectiveModule } from '@bmw-ds/components';

import { useI18n } from '../../../i18n/services/i18n.service';

@Component({
  selector: 'cdf-sync-status',
  imports: [DsIconModule, DsButtonModule, DsTooltipDirectiveModule, DsTagModule],
  template: `
    @if (syncStatus() !== 'RETAIL_ONLY') {
      <ds-tag icon="check" tone="positive">{{ i18n('nscSync.headerBarNscData') }}</ds-tag>
    } @else {
      <ds-tag icon="alert" tone="critical">{{ i18n('nscSync.headerBarNscData') }}</ds-tag>
    }

    <ds-icon icon="exchange" [class.strikethrough]="syncStatus() !== 'NSC_RETAIL_SYNCED'" size="sm" />

    @if (syncStatus() !== 'NSC_ONLY') {
      <ds-tag icon="check" tone="positive">{{ i18n('nscSync.headerBarRetailData') }}</ds-tag>
    } @else {
      <ds-tag icon="alert" tone="critical">{{ i18n('nscSync.headerBarRetailData') }}</ds-tag>
    }
  `,
  styleUrl: './sync-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SyncStatusComponent {
  readonly i18n = useI18n();

  readonly syncStatus = input.required<SyncStatus>();
}

export type SyncStatus = 'NSC_RETAIL_SYNCED' | 'NSC_RETAIL_UNSYNCED' | 'NSC_ONLY' | 'RETAIL_ONLY';
